// extracted by mini-css-extract-plugin
export default {"container":"FiltrosResumo_container__zBPqT","row":"FiltrosResumo_row__ZKvB2","chip":"FiltrosResumo_chip__z+4wq","versus":"FiltrosResumo_versus__dCt9r"};